import { OFFLINE_NAMESPACE } from './constants';
import { isTauri } from './isTauri';
import type { OfflineStorage } from './OfflineStorage';
import { OpfsStorage } from './OpfsStorage';

/**
 * Returns the right storage backend for the current runtime:
 * - Tauri desktop → native filesystem (no quota)
 * - Browser → OPFS
 */
export async function createOfflineStorage(): Promise<OfflineStorage> {
  if (isTauri()) {
    const { NativeFsStorage, createTauriFsBackend } = await import('./NativeFsStorage');
    return new NativeFsStorage(await createTauriFsBackend());
  }
  return OpfsStorage.create(OFFLINE_NAMESPACE);
}
